import Vue from 'vue'
import VueRouter from 'vue-router'

import Default from '@/pages/default'
import Country from '@/pages/default/Country'
import VisaMain from '@/pages/visamain'
import VisaCountry from '@/pages/visacountry'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
     // path: '/',
      path: '/zz_visa',
      name: 'default-view',
      component: Default
    },
    {
      name: 'country',
      path: '/visas/country/:link?',
      component: Country
    },
    {
     // path: '/visas/main',
      path: '/',
      name: 'visamain',
      component: VisaMain
    },
    {
      path: '/visas/country/:site/:webpagetitle',
      name: 'visacountry',
      component: VisaCountry,
    }
  ]
})

